import AirSourceHeatPumpHotWaterCylinderServiceMaintenanceForm from './AirSourceHeatPumpHotWaterCylinderServiceMaintenanceForm';
import AirSourceHeatPumpHotWaterCylinderServiceMaintenancePDF from './AirSourceHeatPumpHotWaterCylinderServiceMaintenancePDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';

export default {
  Form: AirSourceHeatPumpHotWaterCylinderServiceMaintenanceForm,
  PDF: AirSourceHeatPumpHotWaterCylinderServiceMaintenancePDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF
};
